export default {
   login: "/login",
   signup: "/register",
   resetPassword: "/reset-password",
   updatePassword: "/authentication/verify/reset/:email/:otp",
   verifyAccount: "/authentication/verify/:email/:otp",

   dashboard: "/dashboard",
   category: "/dashboard/category",
   categoryDetails: (id) => id ? "/dashboard/category/" + id : "/dashboard/category/:id",
   brands: "/dashboard/brands",
   billings: "/dashboard/billing",
   settings: "/dashboard/settings",
   gallery: "/dashboard/gallery",
   sliders: "/dashboard/sliders",
   users: "/dashboard/users",
   userDetails: (id) => id ? "/dashboard/user/" + id : "/dashboard/user/:id",

   addProduct: "/dashboard/add-product",
   editProduct: (id) => id ? "/dashboard/edit-product/" + id : "/dashboard/edit-product/:id",
   productList: "/dashboard/product-list",

   orders: "/dashboard/order",
   recentOrders: "/dashboard/recent/orders",
   locations: "/dashboard/locations",
   shipping: "/dashboard/shipping",

   marketingTools: "/dashboard/marketing-tools",
   SEOTools: "/dashboard/seo-tools",
   plugins: "/dashboard/plugins",
   socialMediaLinks: "/dashboard/social-media-minks",

   contactUs: "/dashboard/contact-us",
}